import { render, staticRenderFns } from "./home2.vue?vue&type=template&id=c8fc7d70&scoped=true&"
import script from "./home2.vue?vue&type=script&lang=js&"
export * from "./home2.vue?vue&type=script&lang=js&"
import style0 from "./home2.vue?vue&type=style&index=0&id=c8fc7d70&lang=less&scoped=true&"
import style1 from "./home2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fc7d70",
  null
  
)

export default component.exports